import {ensure, hasKey, ObjUtil} from 'yougile-util'
import * as Checkers from './condition-checkers'
import {Context} from './context'
import {NumberValue} from './number-value'
import {TasksValue} from './tasks-value'
import {TypedValue} from './values'

export type Condition<C = TypedValue> =
  | boolean
  | {not: Condition}
  | {and: Condition[]}
  | {or: Condition[]}
  | {
      eq?: unknown[] // todo: fix typing
      less?: NumberValue[]
      more?: NumberValue[]
    }
  | {contains: unknown; inside: C | string}
  | {completed: TasksValue}
  | {exists: C} // ?
  | {empty: C}

export interface Conditional {
  when?: Condition[]
}

export const checkConditional = async (
  conditional: Conditional,
  ctx: Context
): Promise<boolean> => {
  if (!conditional.when) {
    return true
  }
  for (const condition of conditional.when) {
    if (!(await checkCondition(condition, ctx))) {
      return false
    }
  }
  return true
}

export const checkCondition = async (
  condition: Condition,
  ctx: Context
): Promise<boolean> => {
  if (typeof condition === 'boolean') {
    return condition
  }

  if (hasKey(condition, 'not')) {
    return !(await checkCondition(condition.not, ctx))
  }

  if (hasKey(condition, 'and')) {
    ensure(condition.and instanceof Array, 'Incorrect and condition')
    if (condition.and.length === 0) {
      return false
    }
    for (const c of condition.and) {
      if (!(await checkCondition(c, ctx))) {
        return false
      }
    }
    return true
  }

  if (hasKey(condition, 'or')) {
    ensure(condition.or instanceof Array, 'Incorrect or condition')
    for (const cond of condition.or) {
      if (await checkCondition(cond, ctx)) {
        return true
      }
    }
    return false
  }

  for (const checker of ObjUtil.values(Checkers)) {
    const value = await checker(condition, ctx)
    if (typeof value === 'boolean') {
      return value
    }
  }
  return false
}
